module.exports = __webpack_public_path__ + "media/images/elionline/icons/player_calcolatrice-3dd2724f637ec5d235cb15d4cb1e8c13.svg";